<template>
    <div>
        <micro-class-screen :isTestPaper="true" v-bind:fromIndexRes="fromIndexResouresData"></micro-class-screen>
        <test-paper-view @isplay="isplay" @isUpload="isUpload" @upLoadData='upLoadData'></test-paper-view>
        <paly-material v-show="isPlayMaterial" @closePlayer="closePlayer"></paly-material>
        <up-load-test v-if="isShowUpload" @closeUpload="closeUpload" :datas="datas"></up-load-test>
    </div>

</template>
<script>
import MicroClassScreen from '../MicroClassScreen/testPaperScreen.vue'
import testPaperView from '../testPaperView/testPaperView.vue'
import palyMaterial from '../playMaterial/playMaterial.vue'
import upLoadTest from '../upLoad/upLoadTest.vue'
export default {
    name:'testPaper',
    props:{
      fromIndexResouresData:{
        type:Object,
        default:null
      }
    },
    components:{MicroClassScreen,testPaperView,palyMaterial,upLoadTest},
    data(){
        return{
            isPlayMaterial:false,
            isShowUpload:false,                             //是否显示上传组件  false 不显示
            datas:null
        }
    },
    mounted() {
      this.$nextTick(()=>{
        $(document).scrollTop(0);
      })
    },
    methods:{
        isplay(msg){
            this.isPlayMaterial = msg;
        },
        closePlayer(msg){
            this.isPlayMaterial = msg;
        },
        isUpload(obj){
            this.isShowUpload = obj;        //打开上传组件
        },
        closeUpload(msg){
            this.isShowUpload = msg;
        },
        upLoadData(msg){
            this.datas = msg;
        },
        gradeData(msg){
          this.gradeDatas = msg;
        },
        subjectData(msg){
          this.subjectDatas = msg;
        },
        versionData(msg){
          this.versionDatas = msg;
        }
    }
}
</script>
<style lang="">
</style>



// WEBPACK FOOTER //
// src/components/testPaper/testPaper.vue